"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hfround;

var _lib = require("./lib");

/**
 * returns the nearest half precision float representation of a number.
 * @param {number} num
 */
function hfround(num) {
    num = Number(num);

    // for optimization
    if (!Number.isFinite(num) || num === 0) {
        return num;
    }

    const x16 = (0, _lib.roundToFloat16Bits)(num);
    return (0, _lib.convertToNumber)(x16);
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@petamoriken/float16/lib/hfround.js
// module id = 97
// module chunks = 0